import * as yup from 'yup';
import axios from 'axios';
import { withFormik } from 'formik';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';

import LoginForm from './LoginForm';
import actions from '../../../actions';

const mapPropsToValues = () => ({
  username: '',
  password: '',
});

const validationSchema = yup.object().shape({
  username: yup
    .string()
    .email()
    .required(),
  password: yup.string().required(),
});

const handleSubmit = async (values, bag) => {
  try {
    bag.setSubmitting(true);

    const { username, password } = values;

    const response = await axios.post('/api/v1/auth/login', { username, password });

    if (response.data.success) {
      bag.props.dispatch(actions.authSuccess(response.data.token));
      // TODO move it to service
      localStorage.setItem('token', response.data.token);
      bag.props.history.push('/profile'); // TODO to const
    } else {
      bag.setErrors({ summary: response.data.errorMessage || 'Unknown error' });
    }
  } catch (e) {
    bag.setErrors({ summary: (e.response && e.response.data && e.response.data.errorMessage) || 'UNKNOWN ERROR' });
    bag.setFieldValue('password', '', false);
  } finally {
    bag.setSubmitting(false);
  }
};

// TODO why with router is here???
export default compose(
  connect(),
  withRouter,
  withFormik({
    mapPropsToValues,
    validationSchema,
    handleSubmit,
  }),
)(LoginForm);
